<template>
  <!-- Footer -->
  <footer class="_padding-x:1 _padding-y:1-1/2 _background:white">
    <i-container>
      <!-- Navigation Links -->
      <i-row>
        <i-column>
          <div
            class="_display:flex _justify-content:center _align-items:start _margin:0 _margin-bottom:4 footer-nav-wrapper">
            <!-- Column 1 - Learn -->
            <div class="footer-column">
              <h6 class="_text:md _font-weight:semibold _margin-bottom:1/2 _color:dark-50">
                Learn
              </h6>
              <ul class="_list:unstyled _margin:0 _padding:0">
                <li class="_margin-bottom:1/4">
                  <Link
                    class="nav-link -link transition-colors duration-300"
                    :href="route('page.courses')"
                    title="Courses"
                    aria-label="Courses">
                    Courses
                  </Link>
                </li>
                <li class="_margin-bottom:1/4">
                  <Link
                    class="nav-link -link transition-colors duration-300"
                    :href="route('page.certifications')"
                    title="Certifications"
                    aria-label="Certifications">
                    Certifications
                  </Link>
                </li>
              </ul>
            </div>

            <!-- Column 2 - Resources -->
            <div class="footer-column">
              <h6 class="_text:md _font-weight:semibold _margin-bottom:1/2 _color:dark-50">
                Resources
              </h6>
              <ul class="_list:unstyled _margin:0 _padding:0">
                <li class="_margin-bottom:1/4">
                  <Link
                    class="nav-link -link transition-colors duration-300"
                    :href="route('pages.about')"
                    title="Go to About"
                    aria-label="Go to About">
                    About
                  </Link>
                </li>
                <li class="_margin-bottom:1/4">
                  <Link
                    class="nav-link -link transition-colors duration-300"
                    :href="route('blog.index')"
                    title="Go to Blog"
                    aria-label="Go to Blog">
                    Blog
                  </Link>
                </li>
                <li class="_margin-bottom:1/4">
                  <Link
                    class="nav-link -link transition-colors duration-300"
                    :href="route('roadmap.index')"
                    title="Roadmap"
                    aria-label="Go to Roadmap">
                    Roadmap
                  </Link>
                </li>
              </ul>
            </div>

            <!-- Column 3 - Platform -->
            <div class="footer-column">
              <h6 class="_text:md _font-weight:semibold _margin-bottom:1/2 _color:dark-50">
                Platform
              </h6>
              <ul class="_list:unstyled _margin:0 _padding:0">
                <li class="_margin-bottom:1/4">
                  <Link
                    class="nav-link -link transition-colors duration-300"
                    :href="route('page.pricing', '/pricing')"
                    title="All-Access"
                    aria-label="All-Access">
                    All-Access
                  </Link>
                </li>
                <li class="_margin-bottom:1/4">
                  <Link
                    class="nav-link -link transition-colors duration-300"
                    :href="route('creators.index')"
                    title="For Creators"
                    aria-label="For Creators">
                    For Creators
                  </Link>
                </li>
                <li class="_margin-bottom:1/4">
                  <Link
                    class="nav-link -link transition-colors duration-300"
                    :href="route('teams.index')"
                    title="For Teams"
                    aria-label="For Teams">
                    For Teams
                  </Link>
                </li>
              </ul>
            </div>

            <!-- Column 4 - Connect -->
            <div class="footer-column footer-column-last">
              <h6 class="_text:md _font-weight:semibold _margin-bottom:1/2 _color:dark-50">
                Connect
              </h6>
              <ul class="_list:unstyled _margin:0 _padding:0">
                <li class="_margin-bottom:1/4">
                  <a
                    class="nav-link transition-colors duration-300"
                    href="https://bsky.app/profile/climate64.com"
                    aria-label="Follow Climate64 on Bluesky"
                    title="Follow Climate64 on Bluesky">
                    Bluesky
                  </a>
                </li>
                <li class="_margin-bottom:1/4">
                  <a
                    class="nav-link transition-colors duration-300"
                    href="https://www.linkedin.com/company/climate64"
                    aria-label="Follow Climate64 on LinkedIn"
                    title="Follow Climate64 on LinkedIn">
                    LinkedIn
                  </a>
                </li>
                <li class="_margin-bottom:1/4">
                  <a
                    class="nav-link transition-colors duration-300"
                    href="https://www.youtube.com/@Climate64"
                    aria-label="Follow Climate64 on YouTube"
                    title="Follow Climate64 on YouTube">
                    YouTube
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <hr class="_padding:0 _margin-top:0 _margin-bottom:1" />
        </i-column>
      </i-row>

      <i-row middle center>
        <i-column _xs="12" _sm="4">
          <div
            class="_display:flex _xs:flex-direction:column _sm:flex-direction:row _flex-wrap:wrap _align-items:center _xs:justify-content:center _sm:justify-content:space-between">
            <p class="_text:md _text:dark-35 _margin:0">
              © 2026 Climate64, LLC - All Rights Reserved.
            </p>
          </div>
        </i-column>
      </i-row>
      <i-row middle center>
        <i-column _xs="12" _sm="4">
          <div class="_display:flex _xs:justify-content:center _sm:justify-content:space-between">
            <p class="_text:md _text:dark-35 _xs:white-space:normal _margin:0">
              <span class="_color:primary">
                <Link
                  class="_text:dark-35"
                  :href="route('pages.terms')"
                  alt="Terms of Service"
                  aria-label="Terms of Service"
                  title="Terms of Service">
                  Terms of Service
                </Link>
                |
                <Link
                  class="_text:dark-35"
                  :href="route('pages.privacy')"
                  alt="Privacy Policy"
                  aria-label="Privacy Policy"
                  title="Privacy Policy">
                  Privacy Policy
                </Link>
              </span>
            </p>
          </div>
        </i-column>
      </i-row>
    </i-container>
  </footer>
</template>

<script setup>
  import { Link } from '@inertiajs/vue3'
</script>

<style scoped>
  .footer-nav-wrapper {
    gap: 3rem;
  }

  .footer-column {
    min-width: 100px;
    text-align: left;
  }

  .footer-column-last {
    margin-right: -0.5rem;
  }

  .nav-link {
    color: rgb(114, 122, 124);
    text-decoration: none;
    display: block;
    transition: color 0.3s ease;
  }

  .nav-link:hover {
    color: #0db4f3;
  }

  @media (max-width: 768px) {
    .footer-nav-wrapper {
      flex-direction: column;
      gap: 0.2rem;
    }

    .footer-column-last {
      margin-right: 0;
    }
  }
</style>
